import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store';

import Login from '../views/Login.vue';
import Register from '../views/Register.vue';

import Home from '../views/Home.vue';

import ScheduleService from '../views/ScheduleService.vue';
import SchedulePlace from '../views/SchedulePlace.vue';
import ScheduleDate from '../views/ScheduleDate.vue';
import ScheduleSpecialist from '../views/ScheduleSpecialist.vue';
import ScheduleSummary from '../views/ScheduleSummary.vue';
import ScheduleConfirmation from '../views/ScheduleConfirmation.vue';

import CancelConfirmation from '../views/CancelConfirmation.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/ingresar',
    name: 'login',
    component: Login,
    meta: {
      redirectIfAuthenticated: true,
    },
  },
  {
    path: '/registro/:step?',
    name: 'register',
    component: Register,
    meta: {
      redirectIfAuthenticated: true,
    },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/agendamiento',
    name: 'schedule',
    redirect: '/agendamiento/servicio',
  },
  {
    path: '/agendamiento/servicio',
    name: 'schedule-service',
    component: ScheduleService,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/agendamiento/:service/lugar',
    name: 'schedule-place',
    component: SchedulePlace,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/agendamiento/:service/fecha',
    name: 'schedule-date',
    component: ScheduleDate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/agendamiento/:service/especialista',
    name: 'schedule-specialist',
    component: ScheduleSpecialist,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/agendamiento/:service/resumen',
    name: 'schedule-summary',
    component: ScheduleSummary,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.hasFullSchedule) {
        return next();
      }

      return next(false);
    },
  },
  {
    path: '/agendamiento/:service/confirmacion',
    name: 'schedule-confirmation',
    component: ScheduleConfirmation,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.hasConfirmation) {
        return next();
      }

      return next(false);
    },
  },
  {
    path: '/agendamiento/anulado',
    name: 'schedule-cancel',
    component: CancelConfirmation,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

const sendPageViewEvent = (to, from, next) => {
  if (typeof window.gtag != 'undefined') {
    
    window.gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS, {
      page_path: to.path,
    });
  }

  next();
};

router.beforeEach((to, from, next) => {
  sendPageViewEvent(to, from, next);

  if (to.matched.some(record => record.meta && record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      return next();
    }

    return next('/ingresar');
  }

  if (
    to.matched.some(
      record => record.meta && record.meta.redirectIfAuthenticated,
    )
  ) {
    if (store.getters.isLoggedIn) {
      return next(false);
    }

    return next();
  }

  next();
});

export default router;
